<template>
  <div>
    <RmHeader
      :category="selectedCategory"
      :is-selected="isSelected"
      @back="backCategory"
    />
    <CategoriesTree
      ref="categories"
      @select="handleSelect"
      @back="handleBack"
    />
  </div>
</template>

<script>
import isEmpty from 'es-toolkit/compat/isEmpty'
import CategoriesTree from './categories_tree.vue'
import RmHeader from './header.vue'

export default {
  components: {
    CategoriesTree,
    RmHeader,
  },
  setup () {
    const global = useGlobal()
    return {
      selectedCategory: global.selectedCategoryInMenu,
      setSelectedCategoryInMenu: global.setSelectedCategoryInMenu,
    }
  },
  computed: {
    isSelected () {
      return !isEmpty(this.selectedCategory)
    },
  },
  mounted () {
    this.setSelectedCategoryInMenu({})
  },
  unmounted () {
    this.setSelectedCategoryInMenu({})
  },
  methods: {
    handleSelect (category) {
      this.setSelectedCategoryInMenu(category)
    },
    handleBack (category) {
      this.setSelectedCategoryInMenu(category)
    },
    backCategory () {
      this.$refs.categories.backCategory()
    },
  },
}
</script>
